var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "business-center 1",
    clipPath: "url(#clip0_13750_57144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00002 18C13.9706 18 18 13.9706 18 9.00002C18 4.02945 13.9706 0 9.00002 0C4.02945 0 0 4.02945 0 9.00002C0 13.9706 4.02945 18 9.00002 18Z",
    fill: "url(#paint0_linear_13750_57144)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_424010064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_424011264",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9936 10.1129H8.28418V8.69922H9.20338C9.64203 9.11571 10.2346 9.37163 10.886 9.37163C11.5373 9.37163 12.1299 9.11571 12.5686 8.69922H13.9936C14.0858 8.69922 14.1604 8.77385 14.1604 8.86602V9.9461C14.1604 10.0382 14.0857 10.1129 13.9936 10.1129Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_424010808",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1708 13.1774H3.82891C3.73674 13.1774 3.66211 13.1027 3.66211 13.0106C3.66211 12.9184 3.73674 12.8438 3.82891 12.8438H14.1708C14.263 12.8438 14.3376 12.9184 14.3376 13.0106C14.3376 13.1027 14.2629 13.1774 14.1708 13.1774Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_424011144",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8858 9.03339C9.72426 9.03339 8.7793 8.08843 8.7793 6.92687C8.7793 5.7653 9.72426 4.82031 10.8858 4.82031C12.0474 4.82031 12.9924 5.7653 12.9924 6.92687C12.9924 8.08843 12.0474 9.03339 10.8858 9.03339ZM10.719 7.96867C10.6113 7.93826 10.5125 7.87881 10.4351 7.79572C10.3723 7.72831 10.376 7.62274 10.4435 7.56003C10.5109 7.49721 10.6163 7.50081 10.6793 7.56836C10.7333 7.62632 10.8067 7.65828 10.8858 7.65828C11.0416 7.65828 11.1683 7.5316 11.1683 7.37592C11.1683 7.17566 11.0858 7.14587 10.8473 7.08904C10.6174 7.03429 10.2699 6.95158 10.2699 6.47761C10.2699 6.19573 10.4602 5.95754 10.719 5.88463V5.78989C10.719 5.69772 10.7937 5.62308 10.8858 5.62308C10.978 5.62308 11.0526 5.69772 11.0526 5.78989V5.88481C11.1604 5.91522 11.2592 5.9747 11.3367 6.05781C11.3995 6.12522 11.3957 6.23077 11.3282 6.2936C11.2608 6.35625 11.1551 6.3525 11.0924 6.28514C11.0398 6.22867 10.9688 6.19685 10.892 6.19523L10.8858 6.19535L10.8798 6.19523C10.7269 6.1984 10.6034 6.32381 10.6034 6.47751C10.6034 6.67777 10.6859 6.70756 10.9244 6.76439C11.1543 6.81911 11.5018 6.90183 11.5018 7.37582C11.5019 7.65783 11.3116 7.89604 11.0526 7.96892V8.06374C11.0526 8.15594 10.978 8.23055 10.8858 8.23055C10.7937 8.23055 10.719 8.15591 10.719 8.06374L10.719 7.96867Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_424011024",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6244 13.1798H11.9514C11.8592 13.1798 11.7846 13.1052 11.7846 13.013V11.8587H10.2536V13.0131C10.2536 13.1053 10.1789 13.1798 10.0868 13.1798L11.9514 13.1798C12.0434 13.1798 12.1182 13.1053 12.1182 13.0131V11.8587H13.7912V13.0131C13.7912 13.1053 13.7164 13.1798 13.6244 13.1798ZM9.91998 11.8587H8.28405V13.0131C8.28405 13.0715 8.27409 13.1276 8.25586 13.1798H10.0868C9.99463 13.1798 9.91998 13.1052 9.91998 13.013L9.91998 11.8587ZM8.28405 11.5251V10.4531H9.91998V11.5251H8.28405ZM10.2536 10.4531H11.7845V11.5251H10.2536V10.4531ZM12.1182 10.4531H13.7912V11.5251H12.1182V10.4531Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_424010832",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77851 13.1804H6.82284C6.91503 13.1804 6.98966 13.1058 6.98966 13.0135V11.5585C6.98966 11.4664 6.91503 11.3917 6.82284 11.3917H5.33037C5.2382 11.3917 5.16357 11.4664 5.16357 11.5585V13.0135C5.16357 13.1057 5.2382 13.1804 5.33037 13.1804H4.37483C4.28266 13.1804 4.20802 13.1057 4.20802 13.0135V10.667H6.07114L6.07667 10.6671L6.08219 10.667H7.94531V13.0136C7.94531 13.1058 7.87067 13.1804 7.77851 13.1804ZM5.49716 12.9526H6.65603V11.7254H5.49716V12.9526ZM4.20802 10.3334V9.32927H5.90986V10.3334H4.20802ZM6.24346 9.32927H7.9453V10.3334H6.24346V9.32927ZM4.20802 8.99567V8.1043C4.20802 8.01213 4.28265 7.9375 4.37482 7.9375H7.77849C7.87066 7.9375 7.94529 8.01213 7.94529 8.1043V8.99567H4.20802Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_424010448",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9834 7.59768V7.05743C4.9834 6.96526 5.05803 6.89062 5.1502 6.89062H7.00449C7.09665 6.89062 7.17131 6.96526 7.17131 7.05743V7.59768H4.9834Z",
    fill: "#FEFEFE"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13750_57144",
    x1: 0,
    y1: 9.00002,
    x2: 18,
    y2: 9.00002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3538CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0901961,
    stopColor: "#3538CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231373,
    stopColor: "#3538CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368627,
    stopColor: "#3538CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521569,
    stopColor: "#3538CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960784,
    stopColor: "#3538CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3538CD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13750_57144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCenter);
export default __webpack_public_path__ + "static/media/businessCenter.83a2c2524c6e67fd7cc789fba6423f84.svg";
export { ForwardRef as ReactComponent };